var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.29998 15.6004H19.7V5.70039H5.29998V15.6004ZM13.4 17.4004V19.2004H17V21.0004H7.99998V19.2004H11.6V17.4004H4.39278C4.27459 17.3997 4.15771 17.3757 4.04883 17.3297C3.93995 17.2837 3.84121 17.2167 3.75827 17.1325C3.67533 17.0484 3.60982 16.9486 3.5655 16.8391C3.52117 16.7295 3.49891 16.6123 3.49998 16.4941V4.80669C3.49998 4.30629 3.90948 3.90039 4.39278 3.90039H20.6072C21.1004 3.90039 21.5 4.30449 21.5 4.80669V16.4941C21.5 16.9945 21.0905 17.4004 20.6072 17.4004H13.4Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerLine);
export default __webpack_public_path__ + "static/media/computer-line.ac863086d938b9db6f927cf759c90d0e.svg";
export { ForwardRef as ReactComponent };